import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";

const Meetings = () => {
  return (
    <Routes>
      <Route path="/:id" element={<View />} />
      <Route path="/" element={<List />} />
    </Routes>
  );
};

export default Meetings;
